(function() {
  function addReviewCountToAccordion() {
    var container = document.querySelector('.klaviyo-reviews-accordion');
    var tab = container.querySelector('.kl_reviews__list__tab_buttons .kl_reviews__list__tab small');
    var count = tab && tab.textContent ? tab.textContent.trim() : '';
    if (!count) return;
    var accordionContent = container.querySelector('details summary .summary__title .klaviyo-reviews-accordion__count');
    if (!accordionContent) return;
    var details = accordionContent.closest('details');
    if (!details) return;
    var countEl = details.querySelector('summary .summary__title .klaviyo-reviews-accordion__count');
    if (!countEl || countEl.getAttribute('data-reviews-count-set')) return;
    countEl.textContent = '(' + count + ')';
  }
  function run() {
    addReviewCountToAccordion();
  }
  setTimeout(run, 1000);
})();
